/* @flow */
import { nameValidator, emailValidator, passwordValidator, confirmValidator } from './';

const submitNewAccount = (
  name: String,
  email: String,
  informaOnly: Boolean,
  password: String,
  confirmation: String,
  createAccount: Function,
  toggleError: Function,
  updateErrorMessage: Function,
  errorMessages: Array<string>,
  ) => {

  const validations = [
    {
      type: 'confirmation',
      value: confirmValidator(password, confirmation),
    },
    {
      type: 'password',
      value: passwordValidator(password),
    },
    {
      type: 'email',
      value: emailValidator(email, informaOnly),
    },
    {
      type: 'name',
      value: nameValidator(name),
    },
  ];

  for (const validation of validations) {
    if (!validation.value) {
      switch (validation.type) {
        case 'name':
          updateErrorMessage(errorMessages.nameNotValid: String);
          break;
        case 'email':
          updateErrorMessage(errorMessages.emailNotValid: String);
          break;
        case 'password':
          updateErrorMessage(errorMessages.passwordNotValid: String);
          break;
        case 'confirmation':
          updateErrorMessage(errorMessages.passwordsNotEqual: String);
          break;
        default:
          updateErrorMessage('');
      }
    }
  }

  const validation =
    nameValidator(name)
    && emailValidator(email, informaOnly)
    && passwordValidator(password)
    && confirmValidator(password, confirmation)
  ;

  if (validation) {
    createAccount(name, email, password, confirmation);
  } else {
    toggleError(true);
  }
};

export default submitNewAccount;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/enhancers/validators/submitNewAccount.js
 **/